"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgSkiLuggage = function SvgSkiLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#17181A"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 15.625a1 1 0 0 1 1-1h13.29a1 1 0 0 0 .362-.068l.7-.27c.433-.168.95-.019 1.078.428.066.231.088.477-.017.67-.15.28-.715.736-1.195 1.093a2.753 2.753 0 0 1-1.646.522H5a1 1 0 0 1-1-1v-.375zm0 4a1 1 0 0 1 1-1h13.29a1 1 0 0 0 .362-.068l.7-.27c.433-.168.95-.019 1.078.428.066.231.088.477-.017.67-.15.28-.715.736-1.195 1.093a2.753 2.753 0 0 1-1.646.522H5a1 1 0 0 1-1-1v-.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.262 15.793h4.076m-4.076 4.002h4.076"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgSkiLuggage);
var _default = Memo;
exports["default"] = _default;